<template>
    <div
        class="mt-2 flex w-full items-center justify-between gap-3 rounded-[6px] border border-red-100 bg-red-50 p-2.5"
    >
        <div class="flex min-w-0 items-center">
            <img :src="LETTR_LOGO" class="h-8 w-8 shrink-0" alt="" />

            <div class="ml-2 min-w-0 text-left">
                <div class="text-sm font-medium text-gray-700">Lettr</div>
                <div class="truncate text-sm text-gray-500">
                    Stays editable after export
                </div>
            </div>
        </div>

        <AtomicButton color="yellow" size="sm" @click="connect">
            Connect
        </AtomicButton>
    </div>
</template>

<script lang="ts" setup>
import { router } from '@inertiajs/vue3';
import { route } from 'ziggy-js';

/**
 * The same square the export list uses for a connected integration, so the
 * prompt and the row it becomes are recognisably the same thing.
 */
const LETTR_LOGO =
    'https://d1vyenbk43iobe.cloudfront.net/application/images/lettr.png';

const connect = () => {
    router.visit(route('integrations.available.index'));
};
</script>
